import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/Login";
import Books from "../components/Books";

import auth from '../auth';

Vue.use(Router);

function booksRouteHook (to, from, next) {
  if (!auth.isAuthenticated()) {
    next({name: 'Login'})
  } else {
    next()
  }
}

function loginRouteHook (to, from, next) {
  if (auth.isAuthenticated()) {
    next({name: 'Books'})
  } else {
    next()
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: loginRouteHook
    },
    {
      path: '/books',
      name: 'Books',
      component: Books,
      beforeEnter: booksRouteHook
    }
  ]
})